import styled from 'styled-components';

const OnlineOnboardingStepperSC = styled.div`
  .stepper-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 32px;
    padding: 0 20px;
  }

  .step-wrapper {
    display: flex;
    align-items: center;
    position: relative;
  }

  .step {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    min-width: 80px;
  }

  .step-circle {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
    transition: all 0.3s ease;
    border: 2px solid transparent;
  }

  .step-number {
    font-weight: 600;
    font-size: 16px;
  }

  /* New: style for skip icon glyph */
  .step.skipped .skip-icon {
    color: #ffc107; /* orange (amber) */
    font-size: 18px;
    line-height: 1;
    display: inline-block;
    transform: translateY(1px); /* slight optical align */
    font-weight: 700;
  }

  .step-label {
    font-size: 12px;
    font-weight: 500;
    line-height: 1.2;
    max-width: 80px;
    word-wrap: break-word;
  }

  .step-sublabel {
    display: block;
    font-size: 10px;
    margin-top: 2px;
    color: #ffc107; /* amber */
    font-weight: 600;
  }

  .step-connector {
    width: 40px;
    height: 2px;
    margin: 0 8px;
    margin-bottom: 24px;
    transition: all 0.3s ease;
  }

  /* Pending state */
  .step.pending .step-circle {
    background-color: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.3);
  }

  .step.pending .step-number {
    color: rgba(255, 255, 255, 0.6);
  }

  .step.pending .step-label {
    color: rgba(255, 255, 255, 0.6);
  }

  .step-connector {
    background-color: rgba(255, 255, 255, 0.2);
  }

  /* Active state */
  .step.active .step-circle {
    background-color: #ffffff;
    border-color: #ffffff;
    box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.2);
  }

  .step.active .step-number {
    color: #007bff;
  }

  .step.active .step-label {
    color: #ffffff;
    font-weight: 600;
  }

  /* Completed state */
  .step.completed .step-circle {
    background-color: #28a745;
    border-color: #28a745;
  }

  .step.completed .step-label {
    color: #ffffff;
  }

  .step-connector.completed {
    background-color: #28a745;
  }

  /* Skipped state */
  .step.skipped .step-circle {
    background-color: rgba(255, 193, 7, 0.15); /* amber soft */
    border-color: #ffc107;
  }

  .step.skipped .step-number {
    color: #ffc107;
  }

  .step.skipped .step-label {
    color: #ffffff;
  }

  /* Dots indicator for mobile */
  .dots-indicator {
    display: none;
    align-items: center;
    gap: 4px;
    margin: 0 8px;
    margin-bottom: 24px;
  }

  .dots-indicator .dot {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.4);
  }

  .mobile-only {
    display: none;
  }

  .mobile-hidden {
    display: flex;
  }

  /* Mobile responsive */
  @media (max-width: 768px) {
    .stepper-container {
      padding: 0 10px;
      margin-top: 24px;
    }

    .mobile-hidden {
      display: none !important;
    }

    .mobile-only {
      display: flex !important;
    }

    .step {
      min-width: 70px;
    }

    .step-circle {
      width: 36px;
      height: 36px;
      margin-bottom: 6px;
    }

    .step-number {
      font-size: 14px;
    }

    .step-label {
      font-size: 11px;
      max-width: 70px;
    }

    .step-sublabel {
      font-size: 9px;
    }

    .step-connector {
      width: 40px;
      margin: 0 6px;
      margin-bottom: 20px;
    }

    .step.skipped .skip-icon {
      font-size: 16px;
    }

    .dots-indicator {
      margin-bottom: 20px;
    }
  }

  @media (max-width: 480px) {
    .step {
      min-width: 50px;
    }

    .step-circle {
      width: 28px;
      height: 28px;
    }

    .step-number {
      font-size: 12px;
    }

    .step-label {
      font-size: 9px;
      max-width: 50px;
    }

    .step-sublabel {
      font-size: 8px;
    }

    .step-connector {
      width: 30px;
      margin: 0 2px;
      margin-bottom: 18px;
    }

    .step.skipped .skip-icon {
      font-size: 15px;
    }
  }
`;

export default OnlineOnboardingStepperSC;
